module.exports = __webpack_public_path__ + "static/media/Next-wo-background.e081b640.svg";